import { Box, Typography } from '@mui/material';
import { getDateForMarketClose } from "../../helpers/DateFormatter";
import { formatTimeDiff } from "../../utils/formatTimeDiff";

export const StatusMessage = ({ marketStatus, occasion: reason, lastFetched }) => {
  const formattedDate = getDateForMarketClose(new Date(lastFetched));
  const timeDiff = Date.now() - new Date(lastFetched).getTime();

  const displayString = formatTimeDiff(timeDiff);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      {reason && (
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          Reason: <Box component="strong" sx={{ color: 'text.primary' }}>{reason}</Box>
        </Typography>
      )}
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {marketStatus === "Open" ? `Prices Last Updated: ${displayString}` : `Prices as of ${formattedDate}`}
      </Typography>
    </Box>
  );
};
